// extracted by mini-css-extract-plugin
module.exports = {"quote":"quoteSection-module--quote--2EQcG","image":"quoteSection-module--image--8rvfH","text":"quoteSection-module--text--2EG8R"};